import { useTranslation } from 'react-i18next';
import { Title } from 'ui';
import { useUser } from 'features/auth';
import type { GreetingsScope } from '../Greetings';

const GreetingsTitle = ({ className, scope }: { className?: string; scope: GreetingsScope }) => {
  const { t } = useTranslation();

  const { railsUserData: viewer } = useUser();

  const getTitle = () => {
    switch (scope) {
      case 'afternoon':
        return t('Good afternoon, {{name}}', { name: viewer.firstName });
      case 'evening':
        return t('Good evening, {{name}}', { name: viewer.firstName });
      case 'morning':
        return t('Good morning, {{name}}', { name: viewer.firstName });
    }
  };

  return (
    <Title className={className} ellipsis={{ rows: 2 }} level={4} marginBottom>
      {getTitle()}
    </Title>
  );
};

export default GreetingsTitle;
